const onWindowIntl = () => {
  require('babel-polyfill');

  // App locales are defined in src/server/config.js
  const { addLocaleData } = require('react-intl');
  const ar = require('react-intl/locale-data/ar');
  const en = require('react-intl/locale-data/en');
  const he = require('react-intl/locale-data/he');
  const ru = require('react-intl/locale-data/ru');
  const zh = require('react-intl/locale-data/zh');
  const ja = require('react-intl/locale-data/ja');

  [en, ar, he, ru, zh, ja].forEach(locale => addLocaleData(locale));

  require('./main');
};

// github.com/andyearnshaw/Intl.js/#intljs-and-browserifywebpack
if (!window.Intl && typeof require.ensure === 'function') {
  require.ensure(
    [
      'intl',
      'intl/locale-data/jsonp/ar.js',
      'intl/locale-data/jsonp/he.js',
      'intl/locale-data/jsonp/en.js',
      'intl/locale-data/jsonp/zh.js',
      'intl/locale-data/jsonp/ja.js',
      'intl/locale-data/jsonp/ru.js'
    ],
    require => {
      require('intl');
      require('intl/locale-data/jsonp/ar.js');
      require('intl/locale-data/jsonp/en.js');
      require('intl/locale-data/jsonp/he.js');
      require('intl/locale-data/jsonp/zh.js');
      require('intl/locale-data/jsonp/ja.js');
      require('intl/locale-data/jsonp/ru.js');

      onWindowIntl();
    },
  );
} else {
  onWindowIntl();
}



// WEBPACK FOOTER //
// ./src/client/index.js